import type { AccountingTypesParams, BudgetStatusParams } from '../hooks';
import type { UseReservedProjectsParams } from '../reserved-project/_hooks/reserved-project';

export const queryKeyMap = {
  accountingTypes: (params?: AccountingTypesParams) =>
    ['accountingTypes', params].filter((item) => item !== undefined),
  expenditureBudgetPurpose: (id?: string) =>
    ['expenditureBudgetPurpose', id].filter((item) => item !== undefined),
  reservedProjects: (params?: UseReservedProjectsParams) =>
    ['reservedProjects', params].filter((item) => item !== undefined),
  reservedProject: (id?: string) =>
    ['reservedProject', id].filter((item) => item !== undefined),
  expenditureBudgetPurposeNestedExpenditurePurposeOptions: (params?: object) =>
    ['expenditureBudgetPurposeNestedExpenditurePurposeOptions', params].filter(
      (item) => item !== undefined,
    ),
  nestedExpenditureBudgetPurposeOptions: (params?: object) =>
    ['nestedExpenditureBudgetPurposeOptions', params].filter(
      (item) => item !== undefined,
    ),
  budgetStatuses: (params?: BudgetStatusParams) =>
    ['budgetStatuses', params].filter((item) => item !== undefined),
  ministries: () => ['ministries'],
  ministriesListAvailable: () => ['ministriesListAvailable'],
  ministry: (id?: string) =>
    ['ministry', id].filter((item) => item !== undefined),
};

export const invalidateListMap = {
  updateExpenditureBudgetPurpose: () => [
    queryKeyMap.expenditureBudgetPurpose(),
    queryKeyMap.expenditureBudgetPurposeNestedExpenditurePurposeOptions(),
    queryKeyMap.nestedExpenditureBudgetPurposeOptions(),
  ],
  updateMinistries: () => [
    queryKeyMap.ministries(),
    queryKeyMap.ministriesListAvailable(),
  ],
};
